<template>
    <div id="footer">
        <div id="footerHeader">
            <!-- Construction Message-->
            <div v-show="showContactUs" id="constructionMessage">
                <p v-html="slogan"></p>
            </div>
            <div v-show="showContactUs" id="contactMessage">
                <h2>{{ footerMessage }}</h2>
            </div>
            <!-- Right clip -->
            <div id="footerBackground">
                <img src="../assets/footer-background.svg"/>
            </div>
            <!-- Right clip icons-->
            <div class="footerIcons">
                <ul>
                    <li class="footerIcon ">
                        <a href="https://medium.com/ot-design"><img class="medium" src="../assets/medium.svg"/></a>
                    </li>
                </ul>
            </div>
        </div>
        <Contact v-show="showContactUs" v-on:emailSent="showThankYou"/>
    </div>
</template>

<script>
	import Contact from "./Contact"

	export default {
		name: "Footer",
		components: {Contact},

		props: {
			showContact: {
				type: Boolean,
				default: false,
			}
		},
		data() {
			return {
				message: 'Work with us'
			}
		},
		computed: {
			slogan() {
				return this.$store.state.slogan
			},
			footerMessage() {
				return this.message
			},
			showContactUs() {
				return this.showContact
			}
		},
		methods: {
			showThankYou: function () {
				this.message = 'We will be in touch soon'
				this.showContact = false
				this.$emit('emailSent')
			}
		}
	};
</script>

<style lang="scss" src="../styles/footer.scss" scoped/>
